export default "__VITE_ASSET__B2tRTqJY__"